export function deprecatedClassnames(...args: Array<string | undefined>) {
  return args.filter(Boolean).join(' ');
}
